import { Component, OnInit } from '@angular/core';
import { ConfirmDialogService } from './confirm-dialog.service';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {
  constructor(private confirmDialogService: ConfirmDialogService) { }
  message: any;
  ngOnInit() {
    this.confirmDialogService.getMessage().subscribe(message => {
      console.log(message);
      this.message = message;
    });
  }



}
